import { useCurrentAccount, useIsAppAdmin } from '@alliance-disposal/client';
import { useSourContext } from '@wayste/sour-context';
import { Dialog } from '@wayste/sour-ui';
import SppNewAccountDialog from './spp-new-account-dialog';
import WaysteNewAccountDialog from './wayste-new-account-dialog';

interface Props {
    open: boolean;
    onClose: () => void;
}

const NewAccountDialog = ({ open, onClose }: Props) => {
    const { hauler } = useCurrentAccount();
    const { isAdmin } = useIsAppAdmin();
    const { setShowToast } = useSourContext();

    const handleOnClose = (finished?: boolean) => {
        if (isAdmin || finished) {
            onClose?.();
        } else {
            setShowToast({
                severity: 'info',
                message: 'You must complete the account setup to continue.',
            });
        }
        return;
    };

    return (
        <Dialog
            open={open}
            className="min-h-[70dvh] w-full max-w-screen-lg"
            onClose={handleOnClose}
            styledTitle="New Account Setup"
            showX={isAdmin}
            dialogBodyClassName="flex flex-1 w-full"
        >
            {hauler.waysteLite ? <SppNewAccountDialog onClose={handleOnClose} /> : <WaysteNewAccountDialog onClose={handleOnClose} />}
        </Dialog>
    );
};

export default NewAccountDialog;
